import type { Optional } from '@festina-life/core'
import { createContext, useContext } from 'react'

export type VariantIdentifier = {
  scenarioId: string
  variantId: string
  commandId?: string
}

export const variantIdentifierToString = ({
  scenarioId,
  variantId,
}: VariantIdentifier) => `${scenarioId}::${variantId}`

type ScenarioContextType = {
  /** False only when read outside of a `ScenarioProvider`, used to detect nested providers. */
  isProvided: boolean
  variantIdentifier: Optional<VariantIdentifier>
  compareVariantIdentifier: Optional<VariantIdentifier>
  isComparing: boolean
  useRealBenefit: boolean
  scenarioIdForRequestHeader: string | undefined
  simulationDate?: string
  onChangeVariantIdentifier: (nextValue: Optional<VariantIdentifier>) => void
  onChangeCompareVariantIdentifier: (
    nextValue: Optional<VariantIdentifier>,
  ) => void
  onChangeIsComparing: (nextValue: boolean) => void
  onChangeUseRealBenefit: (nextValue: boolean) => void
  onChangeSimulationDate: (nextValue: string | undefined) => void
  resetScenarioState: () => void
}

const ScenarioContext = createContext<ScenarioContextType>({
  isProvided: false,
} as ScenarioContextType)

const useScenarioContext = () => useContext(ScenarioContext)
const Provider = ScenarioContext.Provider

export { Provider, useScenarioContext }
